export class EmailSenderViewModel
{
    opened: boolean = false;
    sending: boolean = false;

    emailSubject: string = '';
    emailBody: string = '';
    recipientIds: number[] = [];

    show(recipientIds: number[])
    {
        this.sending = false;
        this.emailSubject = "Please complete this survey";
        this.emailBody = "Please click on the following link to complete your survey: {url}";
        this.recipientIds = recipientIds;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.sending = false;
        this.emailSubject = '';
        this.emailBody = '';
        this.recipientIds = [];
    }
}

export class EmailSenderFormSubmitEventPayload
{
    emailSubject: string;
    emailBody: string;
    recipientIds: number[];
    constructor(emailSubject: string, emailBody: string, recipientIds: number[])
    {
        this.emailSubject = emailSubject;
        this.emailBody = emailBody;
        this.recipientIds = recipientIds;
    }
}